import AlertCircle from '@/assets/icons/alert-circle-green.svg';

const AlertCircleComponent = () => (
    <div className="p-[16px] sm:p-[20px] bg-primary-1200 inline-flex items-center justify-center rounded-full">
        <img width={40} height={40} src={AlertCircle} />
    </div>
)

export default AlertCircleComponent;
